import React from 'react';

export default function SalesIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1658_882)'>
        <path
          d='M10.6663 5.33337H6.66634C6.31272 5.33337 5.97358 5.47385 5.72353 5.7239C5.47348 5.97395 5.33301 6.31309 5.33301 6.66671C5.33301 7.02033 5.47348 7.35947 5.72353 7.60952C5.97358 7.85956 6.31272 8.00004 6.66634 8.00004H9.33301C9.68663 8.00004 10.0258 8.14052 10.2758 8.39057C10.5259 8.64061 10.6663 8.97975 10.6663 9.33337C10.6663 9.687 10.5259 10.0261 10.2758 10.2762C10.0258 10.5262 9.68663 10.6667 9.33301 10.6667H5.33301M7.99967 12V4.00004M14.6663 8.00004C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8.00004C1.33301 4.31814 4.31778 1.33337 7.99967 1.33337C11.6816 1.33337 14.6663 4.31814 14.6663 8.00004Z'
          stroke='url(#paint0_linear_1658_882)'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1658_882'
          x1='1.22999'
          y1='-1.40619'
          x2='10.909'
          y2='12.7809'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_1658_882'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
